export const ArrowUp = ({ width = 16, height = 16, color = "#2B9E77" }) => (
    <div style={{
        border: "1px solid rgba(43, 158, 119, 0.12)",
        borderRadius: "100px",
        padding:' 2px',
        width,
        height,
        background: 'rgba(43, 158, 119, 0.12)'
    }}>
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M6 11.25C6.20711 11.25 6.375 11.0821 6.375 10.875V2.03033L8.73483 4.39017C8.88128 4.53661 9.11872 4.53661 9.26517 4.39017C9.41161 4.24372 9.41161 4.00628 9.26517 3.85983L6.26517 0.859835C6.11872 0.713388 5.88128 0.713388 5.73484 0.859835L2.73483 3.85983C2.58839 4.00628 2.58839 4.24372 2.73483 4.39017C2.88128 4.53661 3.11872 4.53661 3.26517 4.39017L5.625 2.03033V10.875C5.625 11.0821 5.79289 11.25 6 11.25Z"
                  fill={color} />
        </svg>
    </div>

);
